'use client'

import { firebaseConfig, firebaseFcmStorageId } from '@/helpers/firebase'
import { initializeApp } from '@firebase/app'
import { getMessaging, getToken, onMessage } from '@firebase/messaging'
import { getStoreExperience, getUser } from '@utsubo/experience'
import { setStoreUI } from '@utsubo/ui'

const createLocalNotification = async (
  title,
  body,
  params,
  onlyUnfocused = true // NOTE Ping user only when app tab / browser is not in-focus
) => {
  if (onlyUnfocused) {
    const isAppInFocus = typeof document !== 'undefined' && document.visibilityState !== 'hidden'

    if (isAppInFocus) {
      return
    }
  }

  setStoreUI(s => ({
    notificationQueue: [
      ...s.notificationQueue,
      {
        title,
        body,
        params,
      }
    ]
  }))
}

const registerPushNotifications = async ({
  user,
  vapidKey
}) => {
  if (typeof navigator === 'undefined' || typeof Notification === 'undefined') {
    return
  }

  const firebaseApp = initializeApp(firebaseConfig)
  const firebaseMessaging = getMessaging(firebaseApp)

  
  if ('Notification' in window) {
    const permission = await Notification.requestPermission()

    if (permission !== 'granted') {
      localStorage.removeItem(firebaseFcmStorageId)

      return
    }
  } else {
    // No Notification support, gracefully degrade
    return
  }


  // NOTE Retrieve token from user if there was a token set (allowing multiple devices)
  // NOTE Remove localStorage token when user logs out / not authenticated
  let activeToken = localStorage.getItem(firebaseFcmStorageId)

  if (!activeToken) {
    const { usersById, shareFCMToken } = getStoreExperience()
    const { fcmToken } = usersById[user.uid] || {}

    console.info('registerPushNotifications', 'user', { user: usersById[user.id], fcmToken })

    let newToken

    if (fcmToken) {
      newToken = fcmToken

      console.info('registerPushNotifications', 'existing FCM token', { fcmToken })
    } else {
      newToken = await getToken(firebaseMessaging, { vapidKey })
      
      console.info('registerPushNotifications', 'generate new FCM token', { newToken })
    }

    console.info('registerPushNotifications', 'newToken', { newToken })

    localStorage.setItem(firebaseFcmStorageId, newToken)
    activeToken = newToken

    if (typeof shareFCMToken !== 'function') {
      console.error('registerPushNotifications', 'shareFCMToken is not a function', { shareFCMToken })
    } else {
      shareFCMToken(activeToken)
    }
  }

  onMessage(firebaseMessaging, payload => {
    console.info('pushNotifications', 'push', payload)

    createLocalNotification(
      payload.notification.title,
      payload.notification.body,
      payload.data || {},
      false
    )
  })
}

export const firebaseNotificationHelpers = {
  createLocalNotification,
  registerPushNotifications,
}
